import script from "./MsDebtInvoiceNotify.vue?vue&type=script&setup=true&lang=js"
export * from "./MsDebtInvoiceNotify.vue?vue&type=script&setup=true&lang=js"

import "./MsDebtInvoiceNotify.vue?vue&type=style&index=0&id=e7a81b76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7a81b76"]])

export default __exports__